import { defineStore } from 'pinia';

import * as state from './esign.state';
import * as getters from './esign.getters';
import * as actions from './esign.actions';

export const useEsignStore = defineStore('esign', () => ({
  ...state,
  ...getters,
  ...actions
}));
